import { Get } from "../http/httpVerbs";

export const apiGetPostRewards = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.startDate) {
      queryParams.append("startDate", params.startDate);
    }

    if (params.endDate) {
      queryParams.append("endDate", params.endDate);
    }

    if (params.isVoucherSent !== undefined && params.isVoucherSent !== null) {
      queryParams.append("isVoucherSent", params.isVoucherSent);
    }

    if (
      params.approvedPostsCount !== undefined &&
      params.approvedPostsCount !== null &&
      !Number.isNaN(params.approvedPostsCount)
    ) {
      queryParams.append("approvedPostsCount", params.approvedPostsCount);
    }

    if (
      params.minApprovedPostsCount !== undefined &&
      params.minApprovedPostsCount !== null &&
      !Number.isNaN(params.minApprovedPostsCount)
    ) {
      queryParams.append("minApprovedPostsCount", params.minApprovedPostsCount);
    }

    if (params.page) {
      queryParams.append("page", params.page);
    }

    if (params.limit) {
      queryParams.append("limit", params.limit);
    }

    const url = `${process.env.REACT_APP_API_URL}/post-rewards${queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;

    const response = await Get(url);
    return response;
  } catch (error) {
    console.error("Error fetching post rewards:", error);
    throw error;
  }
};
